import { render, staticRenderFns } from "./PaperDownloadList.vue?vue&type=template&id=32dfe9ce&scoped=true&"
import script from "./PaperDownloadList.vue?vue&type=script&lang=js&"
export * from "./PaperDownloadList.vue?vue&type=script&lang=js&"
import style0 from "./PaperDownloadList.vue?vue&type=style&index=0&id=32dfe9ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dfe9ce",
  null
  
)

export default component.exports